<template>
    
    <v-container fluid>
        <v-layout row>
        <v-flex xs6>
            <p>Object Headers</p>
        </v-flex>

        <v-flex xs6 class="text-xs-right">
            <v-tooltip left dark>
                <template #activator='data'>
                    <v-icon medium="" color="success" @click="addHeader()" v-on="data.on">mdi-plus</v-icon>
                </template>
                <span>Header toevoegen</span>
            </v-tooltip>   
        </v-flex>
        </v-layout>
                            
        <v-container class="pa-0" v-for="(item, index) in type.headers" :key="index">
        <v-layout row align-center="">
            <v-flex xs3>
                <v-autocomplete @change="app.settings.change = true" :items="typeFields" item-text="name" item-value="field" v-model="type.headers[index].value" @input="setHeader(index, type.headers[index].value)"></v-autocomplete>
            </v-flex>
            <v-flex xs3>
                <v-switch color="success" @change="app.settings.change = true" label="Sortable" v-model="type.headers[index].sortable" >{{type.headers[index].text}}</v-switch>
            </v-flex>  
            <v-flex xs6 class="text-right">
                <v-icon color="error" @click="deleteHeader(index)">mdi-minus</v-icon>   
                <v-icon :disabled="index == 0" color="success" @click="downField(index - 1, index)">mdi-chevron-up</v-icon>    
                <v-icon :disabled="index == type.fields.length -1" color="success" @click="upField(index + 1, index)">mdi-chevron-down</v-icon>                                                                                                             
            </v-flex>
        </v-layout>
        </v-container>
    </v-container>      

</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["app", "type"]),
    typeFields() {
      //console.log(this.type.fields);
      var fields = [];
      if (this.type.is_person == true) {
        fields.push({ field: "city", name: "Plaats", type: "text" });
        fields.push({ field: "postal_code", name: "Postcode", type: "text" });
        fields.push({ field: "address", name: "Adres", type: "text" });
        fields.push({ field: "name", name: "Naam", type: "text" });
        fields.push({ field: "first_name", name: "Voornaam", type: "text" });
        fields.push({ field: "last_name", name: "Achternaam", type: "text" });
        fields.push({ field: "initials", name: "Initialen", type: "text" });
        fields.push({ field: "gender", name: "Geslacht", type: "text  " });
        fields.push({
          field: "birth_date",
          name: "Geboortedatum",
          type: "text"
        });
        fields.push({
          field: "birth_place",
          name: "Geboorteplaats",
          type: "text"
        });
        fields.push({ field: "email", name: "Email adres", type: "text" });
        fields.push({ field: "phone", name: "Telefoonnummer", type: "text" });
      }

      if (this.type.is_estate == true) {
        fields.push({ field: "name", name: "Naam", type: "text" });
        fields.push({ field: "city", name: "Plaats", type: "text" });
        fields.push({ field: "postal_code", name: "Postcode", type: "text" });
        fields.push({ field: "buurtnaam", name: "Buurt", type: "text" });
        fields.push({ field: "county", name: "Provincie", type: "text" });
        fields.push({ field: "country", name: "Land", type: "text" });
        fields.push({ field: "perceel", name: "Perceel", type: "text" });
      }

      if (this.type.is_company == true) {
        fields.push({ field: "name", name: "Bedrijfsnaam", type: "text" });
        fields.push({ field: "city", name: "Plaats", type: "text" });
        fields.push({ field: "postal_code", name: "Postcode", type: "text" });
        fields.push({ field: "address", name: "Adres", type: "text" });
        fields.push({ field: "kvk_nummer", name: "KVK nummer", type: "text" });
        fields.push({ field: "btw_nummer", name: "BTW Nummer", type: "text" });
        fields.push({
          field: "business_type",
          name: "Ondernemingsvorm",
          type: "text"
        });
        fields.push({
          field: "email",
          name: "Algemeen Email adres",
          type: "text"
        });
        fields.push({ field: "phone", name: "Telefoonnummer", type: "text" });
      }

      for (let i = 0; i < this.type.fields.length; i++) {
        fields.push({
          field: this.type.fields[i].field,
          name: this.type.fields[i].name,
          type: this.type.fields[i].type
        });
      }

      //console.log(fields);
      return fields;
    }
  },
  methods: {
    deleteHeader(index) {
      this.type.headers.splice(index, 1);
    },
    addHeader() {
      var newField = { text: "", value: "", sortable: "" };
      this.type.headers.push(newField);
    },
    setHeader(index, field) {
      console.log("field", field);
      for (let i = 0; i < this.typeFields.length; i++) {
        if (field == this.typeFields[i].field) {
          this.type.headers[index].text = this.typeFields[i].name;
        }
      }
      console.log(this.type.headers);
    },
    downField(from, to) {
      let data = this.$store.state.type.headers;
      let cutOut = data[from];
      data.splice(from, 1);
      data.splice(to, 0, cutOut);
      this.app.settings.change = true;
    },
    upField(from, to) {
      let data = this.$store.state.type.headers;
      let cutOut = data[from];
      data.splice(from, 1);
      data.splice(to, 0, cutOut);
      this.app.settings.change = true;
    }
  }
};
</script>

